__webpack_require__.p = "/devices/";